<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索储罐..."
        clearable
        icon="ios-search"
        @on-change="searchStorageTank"
        style="width: 250px; margin-right: auto"
      >
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadStorageTank"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.AddStorageTank.openDrawer()"
        >新增储罐租借</Button
      >
    </div>
    <AddStorageTank ref="AddStorageTank" />
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
  </div>
</template>

<script>
import AddStorageTank from "./AddStorageTank.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";

const typeToText = {
  steel: "不锈钢",
  plastic: "塑胶桶",
};
const locationStatusToText = {
  supplier: "供应商",
  shippingToCustomer: "运往客户",
  shippingToFactory: "运往工厂",
  customer: "客户",
  factory: "工厂",
  unknown: "未知",
};
export default {
  name: "StorageTank",
  components: { AddStorageTank },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "编号",
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.AddTankRentalDrawer.openDrawer(params.row);
                    },
                  },
                },
                "#" + params.row.NoId
              ),
            ]);
          },
        },
        {
          title: "储罐名",
          key: "name",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.name);
          },
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            return h("span", typeToText[params.row.type]);
          },
        },
        {
          title: "位置状态",
          key: "locationStatus",
          align: "center",
          render: (h, params) => {
            return h("span", locationStatusToText[params.row.locationStatus]);
          },
        },
        {
          title: "容量/吨",
          key: "weight",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.capacity);
          },
        },
        {
          title: "价格",
          key: "cost",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.cost);
          },
        },
        {
          title: "借用日期",
          key: "rentalTime",
          align: "center",
          render: (h, params) => {
            return h("span", dayjs(params.row.createdAt).format("YYYY-MM-DD"));
          },
        },
      ],
      tableHeight: 300,
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.storageTank.storageTankList,
      totalRows: (state) => state.storageTank.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getStorageTankList: "storageTank/getStorageTankListAction",
    }),
    async loadStorageTank(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.name = this.searchText;

      try {
        this.tableLoading = true;
        await this.getStorageTankList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchStorageTank: _.debounce(function () {
      this.page = 0;
      this.loadStorageTank();
    }, 1000),
  },
  created() {
    this.loadStorageTank();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
